import styled, { css } from 'styled-components';

import { theme } from '../../../common/ui/theme';

const activeStyles = css`
    box-shadow: inset 0 0 0 2px ${theme.colors.accent.emphasis};
    background-color: ${theme.colors.accent.background} !important;
`;

interface StyledDefaultTableBodyRowProps {
    active: boolean;
    selectable: boolean;
    alternateRowColors: boolean;
    disabled?: boolean;
    subtle?: boolean;
    grow?: boolean;
}

const heightStyles = (props: StyledDefaultTableBodyRowProps) => {
    if (props.grow)
        return css`
            > td:has(*) > *:first-child {
                padding-top: 8px;
                padding-bottom: 8px;
            }

            td:not(:has(*)) {
                padding-top: 8px;
                padding-bottom: 8px;
            }
        `;

    return css`
        height: 40px;
    `;
};

const getRowColor = (props: StyledDefaultTableBodyRowProps) => {
    if (props.disabled) {
        return theme.colors.foreground.disabled;
    }

    if (props.subtle) {
        return theme.colors.foreground.subtle;
    }

    return 'inherit';
};

export const StyledDefaultTableBodyRow = styled.tr<StyledDefaultTableBodyRowProps>`
    color: ${(props) => getRowColor(props)};

    &:nth-child(odd) {
        background-color: ${(props) => (props.alternateRowColors ? theme.colors.background.subtle : 'none')};
    }

    &:hover {
        cursor: ${(props) => (props.selectable && !props.disabled ? 'pointer' : 'default')};
    }

    ${(props) => (props.active ? activeStyles : null)}
    ${heightStyles};
`;
